<template>
    <div>
        <div class="">
            <!-- Modal -->
            <div class="modal fade" id="switchAccount" tabindex="-1" aria-labelledby="switchAccount" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title title-modal" id="switchAccount">Swicth Account</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                    <div class="challenger-list-holder">
                            <div class="challengers-list" v-for="option in loadKidsDetails" :key="option.id" @click="switchAccountNow(option)" :class="[selectedValue == option.id ? 'selectedAccount bg-light' : '']">
                                <div class="list-c">
                                    <img v-if="option.avatar_url != null" :src="option.avatar_url" alt="">
                                    <img v-else src="../../assets/images/ray-team.svg" alt="">
                                    <div>
                                        <p>{{option.firstname}} {{ option.lastname }} <span class="d-none d-lg-block">({{ option.relationship }})</span></p>
                                        <small class="relationship d-block d-md-none">({{ option.relationship }})</small>
                                    </div>
                                </div>

                                <div style="padding-bottom: 1.8rem;">
                                    <input :value="option.id" v-model="selectedValue" @click.stop   type="radio" name="cardOption" :id="'radio-' + option.id" class="card-radio form-check-input">
                                </div>
                            </div>
                            <!-- <div class="challengers-list">
                                <div class="list-c">
                                <img src="../../assets/images/ray-team.svg" alt="">
                                <p>Bamidele Orobosa Ejike</p>
                                </div>

                                <h6>254 pts</h6>
                            </div> -->
                    </div>
                    </div>
                    <div class="mb-5">
                        <button class="add-super btn" @click="routeTo('/dashboard/superkid-register')" data-dismiss="modal" aria-label="Close"> 
                            <span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z" fill="#2EBFCA"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 22C14.8501 22 14.0251 22 13.5126 21.4874C13 20.9749 13 20.1499 13 18.5C13 16.8501 13 16.0251 13.5126 15.5126C14.0251 15 14.8501 15 16.5 15C18.1499 15 18.9749 15 19.4874 15.5126C20 16.0251 20 16.8501 20 18.5C20 20.1499 20 20.9749 19.4874 21.4874C18.9749 22 18.1499 22 16.5 22ZM17.0833 16.9444C17.0833 16.6223 16.8222 16.3611 16.5 16.3611C16.1778 16.3611 15.9167 16.6223 15.9167 16.9444V17.9167H14.9444C14.6223 17.9167 14.3611 18.1778 14.3611 18.5C14.3611 18.8222 14.6223 19.0833 14.9444 19.0833H15.9167V20.0556C15.9167 20.3777 16.1778 20.6389 16.5 20.6389C16.8222 20.6389 17.0833 20.3777 17.0833 20.0556V19.0833H18.0556C18.3777 19.0833 18.6389 18.8222 18.6389 18.5C18.6389 18.1778 18.3777 17.9167 18.0556 17.9167H17.0833V16.9444Z" fill="#2EBFCA"/>
                                <path d="M15.4147 13.5074C14.4046 13.1842 13.24 13 12 13C8.13401 13 5 14.7909 5 17C5 19.1406 7.94244 20.8884 11.6421 20.9949C11.615 20.8686 11.594 20.7432 11.5775 20.6201C11.4998 20.0424 11.4999 19.3365 11.5 18.586V18.414C11.4999 17.6635 11.4998 16.9576 11.5775 16.3799C11.6639 15.737 11.8705 15.0333 12.4519 14.4519C13.0334 13.8705 13.737 13.6639 14.3799 13.5774C14.6919 13.5355 15.0412 13.5162 15.4147 13.5074Z" fill="#2EBFCA"/>
                                </svg>
                            </span>
                            Add A SuperKid
                        </button>
                    </div>
                    <!-- <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary">Save changes</button>
                    </div> -->
                    </div>
                </div>
            </div>
            <!-- <div v-else>
                <PageLoader></PageLoader>
            </div> -->
        </div>
    </div>
</template>

<script>
// import { fetchSuperkisParentsKids } from '../../utils';
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import SwitchAccount from "./SwitchAccount"
import moment from "moment";
import $ from "jquery";
export default {
    name: "SwitchAccount",
    components: {
        PageLoader,
        SwitchAccount,
    },

    data() {
        return {
            selectedValue: null,
            loadKidsDetails: null,

        };
    },
    // created() {
    //     if (this.kids > 0) {
    //         console.log("Kido", this.kids)
    //     }
    // },
    mounted() {
        // this.loadKidProfile();
        // console.log("Kidominant", this.$attrs.kidds); 
        this.loadKidsDetails = this.$attrs.kidds
        if ((!localStorage.getItem('kidDetails'))  || (localStorage.getItem('kidDetails') == undefined)) {
            this.selectedValue = JSON.parse(localStorage.getItem('kdDetails').id)
        }
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        switchAccountNow(option) {
            // console.log("pused to LS", option)
            this.selectedValue = option.id;
            localStorage.setItem('kidDetails', JSON.stringify(option));
            this.$bus.$emit('active-kid-updated');
            $("#switchAccount")
            .removeClass("fade")
            .modal("hide");
            window.location.reload();
            
        }
    }
};
</script>


<style scoped lang="scss">

.modal.fade .modal-dialog {
    transform: translate3d(0, 100vh, 0);
    transition: transform 0.3s ease-out;
}

/* Shown state: Slide into view */
.modal.fade.show .modal-dialog {
    transform: translate3d(0, 0, 0);
}

/* Optional: Position at the bottom of the screen */
.modal-bottom .modal-dialog {
    margin: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100%;
}

.title-modal {
        font-family: Nunito;
        font-weight: 800;
        font-size: 20px;
        line-height: 24px;
        color: #1C2B3A;
}

.challengers-list-holder {
  margin-top: 10rem;
  border: 1px solid #F5F7FA;
  background: #ffffff;
  border-radius: 10px;
  gap: 10px;
  // padding: 20px 5px;
}

.list-c {
  display: flex;
  align-items: center;
  gap: 15px;
}
.challengers-list {
  border-bottom: 1px solid #F5F7FA;
  padding: 20px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  img {
    width: 42px;
    height: 42px;
    border-radius: 50px;
    object-fit: cover;
  }
  p {
    font-family: Lato;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    color: #1C2B3A;
    text-align: left;
    margin-bottom: 0;
    display: flex;
    align-items: baseline;
    gap: 10px;
    // padding-left: 10;
    span {
        font-family: Lato;
        font-size: 12px;
        color: #8c8d8e;
    }
  }
  h6 {
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #5D6F7C;
    text-align: right;

  }
}

.relationship {
    font-family: Lato;
    font-size: 12px;
    color: #8c8d8e;
    text-align: left;
    // display: flex !important;
}

input[type="radio"] {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #ccc; /* Unselected ring width */
    border-radius: 50%;
    outline: none;
    cursor: pointer;
}
.form-check-input:checked {
 border-color: #2EBFCA;
 accent-color: #2EBFCA;
}

// input[type="radio"]:checked {
//     border-width: 6px; /* "Ring" thickens when selected */
//     border-color: #2EBFCA;
// }

.add-super {
    font-family: Lato;
    font-weight: 600;
    font-size: 18px;
    color: #2EBFCA;
    outline: 0;
    box-shadow: none;
}

.selectedAccount {
    border-bottom: 1px solid #2EBFCA;
    border-radius: 10px;
}


/* Align to bottom */
// .modal-bottom .modal-dialog {
//     display: flex;
//     align-items: flex-end;
//     min-height: 100%;
//     margin: 0 auto; /* Centers horizontally */
// }

/* Make it full width (optional for mobile feel) */
// .modal-bottom .modal-content {
//     border-radius: 1rem 1rem 0 0; /* Rounded top corners only */
//     border: none;
// }
</style>

